import type { Vec2 } from '../../geo/types';
import { closestPointOnPolyline, polylineLength } from '../../geo/polyline';
import type { PalisadeData } from './palisade';

/** The point of a palisade nearest a layout point, and where it lies along the row. */
export interface OnRow {
  readonly palisade: PalisadeData;
  readonly point: Vec2;
  readonly distance: number;
  /** Metres along the palisade's path. */
  readonly station: number;
  readonly tangent: Vec2;
}

export function onRow(palisade: PalisadeData, p: Vec2): OnRow {
  const near = closestPointOnPolyline(palisade.path, p);
  const before = polylineLength(palisade.path.slice(0, near.segmentIndex + 1));
  const a = palisade.path[near.segmentIndex]!;
  const b = palisade.path[near.segmentIndex + 1] ?? a;
  const station = before + near.t * Math.hypot(b[0] - a[0], b[1] - a[1]);
  return { palisade, point: near.point, distance: near.distance, station, tangent: near.tangent };
}

/** The nearest point of the nearest palisade, none when there are no palisades. */
export function nearestRow(palisades: readonly PalisadeData[], p: Vec2): OnRow | undefined {
  return palisades
    .map((palisade) => onRow(palisade, p))
    .reduce<OnRow | undefined>(
      (best, r) => (!best || r.distance < best.distance ? r : best),
      undefined
    );
}
